import React from 'react';
import logo from "../asset/logo.png"
import {
    
    FaEnvelope,
    FaFacebook,
    FaInstagram,
    FaLinkedin,
    
    FaMap,
    FaPhone,
   
  } from "react-icons/fa";


const Footer2 = () => {
  return (
    <footer className="bg-primer text-white p-8  font-Montserrat m-auto">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          <div className="footer-left items-center  text-center ">
            
            <img className='max-sm:m-auto' src={logo} alt="" />
            <p className="mr-8">
              Copyright © 2023 <strong>ExportTani</strong> All rights reserved
            </p>
          </div>

          <div className="footer-center">

            <div className="mb-3 flex">
             <FaMap className='mr-2 text-3xl' />
              <p className="">
                PT Export Tani Nusantara <span className="block">Jalan Dramaga Cantik N51, Bogor, Jawa Barat, Indonesia</span>
              </p>
            </div>

            <div className="mb-3 flex">
             <FaPhone className='mr-2  text-3xl' />
              <p className="">
              Call me
              <br /> 6281212851807
              </p>
            </div>
            
            <div className=" mb-2 flex">
              <FaEnvelope className='mr-2 text-3xl hover:scale-90' />
              <p className="">
              eksportaninusantara@gmail.com
              </p>
              {/* <p className="max-sm:text-md">
                <a href="mailto:eksportaninusantara@gmail.com">eksportaninusantara@gmail.com</a>
              </p> */}
            </div>
          </div>

          <div className="footer-right ml-4">
            <p className="footer-company-about">
              <span className="text-xl font-bold">About the company</span>
              <br /> 
             <strong>PT Export Tani Nusantara </strong>  is a leading spice supplier from Indonesia. We are a company engaged in manufacturing various spice derivative products with high quality ingredients. </p>
           
        <div className="flex pt-4 text-2xl mt-8">
          <a
            href="https://www.facebook.com/profile.php?id=100082752616177"
            target="_blank"
            rel="noopener noreferrer"
            className="mr-5 hover:scale-150"
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.instagram.com/exporttani/"
            target="_blank"
            rel="noopener noreferrer"
            className="mr-5 hover:scale-150"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/company/pt-export-tani-nusantara/"
            target="_blank"
            rel="noopener noreferrer"
            className="mr-5 hover:scale-150"
          >
            <FaLinkedin />
          </a>
        </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer2;
